import React, { useCallback, useEffect, useState } from 'react'
import { Flex } from 'rebass'
import { useTranslation } from 'react-i18next'
import {
  getPendingTodoList as getTodoListApi,
  completeTodo,
  uncompleteTodo
} from '../api'
import { StorageKeys } from '../types/StorageKeys'
import { Todo } from '../types/Todo'
import { User } from '../types/User'
import { Drawer } from './Drawer/Drawer'
import { styles } from './mainMenuStyles'
import { TaskList } from './TaskList'
import { WellnessCheck } from './WellnessCheck'

export type Sections =
  | 'wellnessMenu'
  | 'wellness'
  | 'todo-pending'
  | 'todo-completed'
  | 'dashboard'
  | 'find'
  | 'appointment'

type MainMenuProps = {
  onWellnessCheck: () => void
  onLogout: () => void
  setWellnessCheckInTodoId: (id: string) => void
}
export const MainMenu = ({
  onWellnessCheck,
  onLogout,
  setWellnessCheckInTodoId
}: MainMenuProps) => {
  const [collapseDrawer, setCollapseDrawer] = useState(false)
  const [activeSection, setActiveSection] = useState<Sections>('todo-pending')
  const [todoList, setTodoList] = useState<Todo[]>([])

  const { t } = useTranslation()

  useEffect(() => {
    const getTodoList = async () => {
      const user: User = JSON.parse(
        localStorage.getItem(StorageKeys.API_USER) || ''
      )
      const token = localStorage.getItem(StorageKeys.API_TOKEN)

      if (user && token) {
        console.log('HERE')
        try {
          const { response, status } = await getTodoListApi(
            user.patient._id,
            token
          )

          if (status === 'error') {
            onLogout()
          }

          setTodoList(response.result)
        } catch (e) {
          console.log(e)
        }
      }
    }

    getTodoList()

    const interval = setInterval(getTodoList, 10 * 60 * 1000) // 10 minutes
    return () => clearInterval(interval)
  }, [onLogout])

  const toggleCheck = (checked: boolean, id: string) => {
    const token = localStorage.getItem(StorageKeys.API_TOKEN)
    if (token) {
      try {
        checked ? completeTodo(id, token) : uncompleteTodo(id, token)

        setTodoList(prev =>
          prev.map(todo => {
            if (todo._id === id) {
              return {
                ...todo,
                status: checked ? 'completed' : 'pending'
              }
            }
            return todo
          })
        )
      } catch (e) {}
    }
  }

  const activePendingTodoSection = useCallback(() => {
    setActiveSection('todo-pending')
    setCollapseDrawer(true)
  }, [])

  const activeCompletedTodoSection = useCallback(() => {
    setActiveSection('todo-completed')
    setCollapseDrawer(true)
  }, [])

  return (
    <Flex sx={styles.container}>
      <Drawer
        activeSection={activeSection}
        collapsed={collapseDrawer}
        setCollapsed={setCollapseDrawer}
        setActiveSection={setActiveSection}
        onLogout={onLogout}
      />

      {activeSection.includes('wellness') ? (
        <WellnessCheck
          active={collapseDrawer && activeSection === 'wellness'}
          setActiveSection={() => {
            setActiveSection('wellness')
            setCollapseDrawer(true)
          }}
          onWellnessCheck={onWellnessCheck}
        />
      ) : activeSection.includes('todo') ? (
        <>
          <TaskList
            title={t('lg.dashboard.todoLists.pending.subtitle')}
            subtitle={t('lg.dashboard.todoLists.pending.title')}
            setActive={activePendingTodoSection}
            active={collapseDrawer && activeSection === 'todo-pending'}
            todoList={todoList.filter(t => t.status === 'pending')}
            toggleCheck={toggleCheck}
            onWellnessCheck={onWellnessCheck}
            setWellnessCheckInTodoId={setWellnessCheckInTodoId}
            animateRight
            focusableClass="focusable-todo-pending"
          />
          <TaskList
            title={t('lg.dashboard.todoLists.completed.subtitle')}
            subtitle={t('lg.dashboard.todoLists.completed.title')}
            setActive={activeCompletedTodoSection}
            active={collapseDrawer && activeSection === 'todo-completed'}
            todoList={todoList.filter(t => t.status === 'completed')}
            toggleCheck={toggleCheck}
            onWellnessCheck={onWellnessCheck}
            focusableClass="focusable-todo-completed"
          />
        </>
      ) : (
        <Flex>Working</Flex>
      )}
    </Flex>
  )
}
